import { render, staticRenderFns } from "./modalCnpj.vue?vue&type=template&id=bb59fb80&scoped=true&"
import script from "./modalCnpj.vue?vue&type=script&lang=js&"
export * from "./modalCnpj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb59fb80",
  null
  
)

export default component.exports